import { render, staticRenderFns } from "./AirwallexDialog.vue?vue&type=template&id=1a69e4c9&scoped=true"
import script from "./AirwallexDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AirwallexDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AirwallexDialog.vue?vue&type=style&index=0&id=1a69e4c9&prod&lang=scss&scoped=true"
import style1 from "./AirwallexDialog.vue?vue&type=style&index=1&id=1a69e4c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a69e4c9",
  null
  
)

export default component.exports